import { useContext } from "react";
import { TNotification, TNotificationData } from "./TNotification";
import { NotificationContext } from "./NotificationContext";

export default function useNotification() {
	const notificationCtx = useContext(NotificationContext);

	return {
		showError: (data: TNotificationData) => {
			notificationCtx?.showNotification({ data, type: "error" });
		},
		showSuccess: (data: TNotificationData) => {
			notificationCtx?.showNotification({ data, type: "success" });
		},
		showInfo: (data: TNotificationData) => {
			notificationCtx?.showNotification({ data, type: "info" });
		},
		showWarning: (data: TNotificationData) => {
			notificationCtx?.showNotification({ data, type: "warning" });
		},
		messageNotification: notificationCtx?.messageNotification,
		notification: notificationCtx?.notification,
	};
}
